import { Field, useFormikContext } from 'formik';
import {
  Autocomplete,
  AutocompleteRenderInputParams
} from 'formik-material-ui-lab';
import { FC } from 'react';
import { TextField as TextFieldMaterial } from '@material-ui/core';
import {
  StatusPayment,
  ParticularTravelStatus
} from 'app/viaje/viajeTraslado/particular/models/particularTravelsModel';

type Props = {
  name: string;
  className?: string;
  placeholder?: string;
  fullWidth?: boolean;
  margin?: 'dense' | 'normal' | 'none';
  variant?: 'outlined' | 'filled' | 'standard';
  disabled?: boolean;
  inputHeight?: string;
};

const statusPaymentOptions = [
  { value: StatusPayment.PAID, label: 'Pagado' },
  { value: StatusPayment.MANUAL_PAYMENT, label: 'Pagado Manual' },
  { value: StatusPayment.PENDING, label: 'Pendiente' },
  { value: StatusPayment.UNPAID, label: 'Impago' }
];

const StatusPaymentSelector: FC<Props> = ({
  name,
  className,
  placeholder = 'Estado de Pago',
  fullWidth = true,
  margin = 'dense',
  variant = 'outlined',
  disabled,
  inputHeight
}) => {
  const { touched, errors, setFieldValue, values } = useFormikContext<any>();

  const getFilteredOptions = () => {
    if (values.state === ParticularTravelStatus.FACTURADO) {
      return statusPaymentOptions.filter(
        (option) =>
          option.value === StatusPayment.PAID ||
          option.value === StatusPayment.MANUAL_PAYMENT
      );
    }
    return statusPaymentOptions;
  };

  const filteredOptions = getFilteredOptions();

  const getOptionLabel = (option: any) => {
    if (typeof option === 'string') {
      const found = statusPaymentOptions.find((opt) => opt.value === option);
      return found ? found.label : option;
    }
    return option?.label || '';
  };

  const isOptionEqualToValue = (option: any, value: any) => {
    if (typeof option === 'string' && typeof value === 'string') {
      return option === value;
    }
    return option?.value === value?.value;
  };

  return (
    <div className="relative">
      <Field
        component={Autocomplete}
        name={name}
        options={filteredOptions}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isOptionEqualToValue}
        renderInput={(params: AutocompleteRenderInputParams) => (
          <TextFieldMaterial
            {...params}
            label={placeholder}
            variant={variant}
            fullWidth={fullWidth}
            margin={margin}
            disabled={disabled}
            error={touched[name] && Boolean(errors[name])}
            helperText={touched[name] && errors[name]}
            style={inputHeight ? { height: inputHeight } : undefined}
          />
        )}
        className={className}
        onChange={(event: any, newValue: any) => {
          setFieldValue(name, newValue?.value || null);
          if (newValue?.value && newValue?.value !== StatusPayment.PAID && newValue?.value !== StatusPayment.MANUAL_PAYMENT) {
            setFieldValue('state', false);
          }
        }}
      />
    </div>
  );
};

export default StatusPaymentSelector;